import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Products from './components/Products';
import ShippingStatus from './components/Shipping_status';
import Product from './components/Product';
import ChannelSync from './components/Channel_sync';
import Offer from './components/Offer';
import OrderPicking from './components/Order_picking';
import Analytics from './components/Analytics';
import Settings from './components/Settings';
import Product_search from './components/Product_search';

class App extends Component {
  render() {
    return (
    <Router>
        <div>
            <Routes>
              <Route exact path='/' element={<Dashboard/>} />
              <Route exact path='/Products' element={<Products/>} />
              <Route exact path='/Shipping_status' element={<ShippingStatus/>} />
              <Route exact path='/Product' element={<Product/>} />
              <Route exact path='/Channel_sync' element={<ChannelSync/>} />
              <Route exact path='/Offer' element={<Offer/>} />
              <Route exact path='/Order_picking' element={<OrderPicking/>} />
              <Route exact path='/analytics' element={<Analytics/>} />
              <Route exact path='/settings' element={<Settings/>} />
              <Route exact path='/product_search' element={<Product_search/>} />
          </Routes>
        </div>
      </Router>
    );
  }
}

export default App;
